import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      organization: null,
      membership: null,
      entitlements: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user && user.email_verified }),
      setSession: (payload) => set({
        user: payload?.user || null,
        organization: payload?.organization || null,
        membership: payload?.membership || null,
        entitlements: payload?.entitlements || null,
        isAuthenticated: !!payload?.user?.email_verified,
      }),
      logout: () => set({
        user: null,
        organization: null,
        membership: null,
        entitlements: null,
        isAuthenticated: false,
      }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
